import styled from '@emotion/styled'
import { NumberInput } from 'components/patterns/Inputs'
import { StyledFieldFooter } from 'components/patterns/Inputs/Field/Field.style'

export const StyledNumberInput = styled(NumberInput)`
  width: 100px;

  ${StyledFieldFooter} {
    white-space: nowrap;
  }
`
